function enableInfiniteCollections () {
 
  document.querySelectorAll('.bundle-collection-content').forEach(section => {
    const productsWrap = section.querySelector('.collection__products');
    const loadMoreBtn = section.querySelector('.load-more');
    const mobileTestimonial = document.querySelector(".mobile-testimonial-box")
    if (!productsWrap || !loadMoreBtn) return;

    const totalCount = +productsWrap.dataset.count;
    let nextUrl = loadMoreBtn.dataset.nextUrl;

    // Optional: Setup IntersectionObserver
    const sentinel = document.createElement('div');
    sentinel.className = 'collection__infinite-trigger-box';
    loadMoreBtn.after(sentinel);
         // px from viewport bottom on mobile
const wrapper     = productsWrap.closest('.bundle-collection-content');

    const observer = new IntersectionObserver(entries => {
     
      entries.forEach(entry => {
        if(entry.target==sentinel){
           if (entry.isIntersecting) {
          
        loadMoreProducts();
        }
    
       
    
        }
        if (entry.target === productsWrap) {

         
      if (entry.isIntersecting) {
        wrapper.classList.add('addSticky');
      } else {
        wrapper.classList.remove('addSticky');
      }
          
    }
        if(entry.target ==mobileTestimonial){
        console.log("enterywrap",entry)
             if(entry.intersectionRatio && entry.intersectionRatio > 0.2){
               console.log("trigger 1")
          wrapper.classList.remove("addSticky")
             }
        }
     
      });
    }, {  threshold: [0,0.2,1],  rootMargin:`-60px 0px 0px 0px` });

    observer.observe(sentinel);
      observer.observe(productsWrap);
    observer.observe(mobileTestimonial);
    loadMoreBtn.addEventListener('click', loadMoreProducts);

    function loadMoreProducts () {
      if (!nextUrl) return;
      fetch(nextUrl)
        .then(res => res.text())
        .then(html => {
              const doc = new DOMParser().parseFromString(html, 'text/html');

      const newCards = doc.querySelectorAll('#collection-page > *');
      const newPagination = doc.querySelector("#paginate a");
         
          newCards.forEach(child => {
  productsWrap.appendChild(child.cloneNode(true)); // clone if you want to preserve original
});
          // Prepare for next page
          const url = new URL(nextUrl, window.location.origin);
          let nextPage = parseInt(url.searchParams.get('page') || '1') + 1;
          const maxPage = Math.ceil(totalCount / 8);
  loadSwiper();
          loadSwiper2();
          if (newPagination) {
            url.searchParams.set('page', nextPage);
            nextUrl = url.pathname + url.search;
            loadMoreBtn.dataset.nextUrl = nextUrl;
          } else {
            loadMoreBtn
            sentinel
            observer.disconnect();
          }
        })
        .catch(console.error);
    }
  });
}

document.addEventListener('DOMContentLoaded', enableInfiniteCollections);




// /**
//  *  @class
//  *  @function CollectionPagination
//  */

// if (!customElements.get('pagination-wrapper')) {
//   class CollectionPagination extends HTMLElement {
//     constructor() {
//       super();
//       console.log("Pagination component initialized");
//       this.button = this.querySelector('[data-click-to-load]');
//       this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
//       this.nextUrl = this.button ? this.button.getAttribute('href') : null;
//     }

//     connectedCallback() {
//       console.log("Pagination connected");

//    this.infinite();

//     }




// infinite() {
//   /**
//    * `pagination` is the <pagination-wrapper> custom element (this instance)
//    * `section` is the surrounding .bundle-collection-content`
//    */
//   const pagination = this;
//   const section    = this.closest('.bundle-collection-content');

//   console.log("Setting up infinite scroll for", section);

 

//   // Create an IntersectionObserver with 20% visibility threshold
//   const observer = new IntersectionObserver((entries) => {
//     entries.forEach(entry => {
//       console.log("Intersection entry:", entry);
//       if (entry.isIntersecting  && pagination.nextUrl) {
//         console.log("loading next page:", pagination.nextUrl);
//         pagination.loadProducts(pagination.nextUrl);
//       }
//     });
//   }, {
//     threshold: 0.05 
//   });

//   // Start observing the section
//   observer.observe(section);

// }



//     loadProducts(url) {
//       const base = this;

//       if (base.getAttribute('loading')) {
//         console.log("Already loading, skipping");
//         return;
//       }

//       console.log("Loading products from", url);
//       base.setAttribute('loading', true);
//       if (base.button) base.button.classList.add('btn--loading');

//       fetch(url)
//         .then(response => response.text())
//         .then((responseText) => {
//           console.log("Received response");
//           const parser = new DOMParser();
//           const doc = parser.parseFromString(responseText, 'text/html');

//           const collectionHandle = base.closest('.bundle-collection-content').dataset.handle;
//           console.log("Looking for collection with handle", collectionHandle);
//           const responseCollection = doc.querySelector(`.bundle-collection-content[data-handle="${collectionHandle}"]`);

//           if (!responseCollection) {
//             console.log("No matching collection found in response");
//             base.removePagination();
//             return;
//           }

//           const products = responseCollection.querySelectorAll('.product-item');
//           const grid = base.closest('.bundle-collection-content').querySelector('.collection__products');
//           console.log(`Found ${products.length} products to append`);

//           products.forEach(product => {
//             grid.appendChild(product);

//             if (product.querySelector('.mySwiper')) {
//               console.log("Initializing swiper for product");
//               new Swiper(product.querySelector('.mySwiper'), {
//                 loop: true,
//                 pagination: {
//                   el: product.querySelector('.swiper-pagination'),
//                   clickable: true,
//                 },
//                 navigation: {
//                   nextEl: product.querySelector('.swiper-button-next'),
//                   prevEl: product.querySelector('.swiper-button-prev'),
//                 },
//               });
//             }
//           });

//           const newPagination = responseCollection.querySelector('.pagination-wrapper');
//           if (newPagination) {
//             const newButton = newPagination.querySelector('[data-click-to-load]');
//             base.nextUrl = newButton ? newButton.getAttribute('href') : null;
//             console.log("Next URL updated to", base.nextUrl);

//             if (!base.nextUrl) {
//               console.log("No more pages available");
//               base.removePagination();
//             } else if (base.button) {
//               base.button.setAttribute('href', base.nextUrl);
//             }
//           } else {
//             console.log("No pagination found in response");
//             base.removePagination();
//           }

//           if (base.animations_enabled) {
//             console.log("Animating new products");
//             gsap.from(products, {
//               duration: 0.5,
//               y: 30,
//               opacity: 0,
//               stagger: 0.05,
//               onComplete: () => base.completeLoading()
//             });
//           } else {
//             console.log("Animations disabled, skipping");
//             base.completeLoading();
//           }

    
//         })
//         .catch((error) => {
//           console.error("Error loading products:", error);
//           base.completeLoading();
//         });
//     }

//     completeLoading() {
//       console.log("Loading complete");
//       this.removeAttribute('loading');
//       if (this.button) this.button.classList.remove('btn--loading');
//     }

//     removePagination() {
//       console.log("Removing pagination");
//       if (this.button) {
//         this.button.classList.add('visually-hidden');
//       } else if (this.observer) {
//         this.observer.disconnect();
//       }
//       this.nextUrl = null;
//     }
//   }

//   customElements.define('pagination-wrapper', CollectionPagination);
// }
